import {
  getOnboardingStepPath as getSharedOnboardingStepPath,
  getStepNameFromOnboardingPath,
  isOnboardingStepResolved,
  isOnboardingLoadingStep,
  OnboardingPath,
  OnboardingResponseState,
  StepName,
} from "@jurni/schemas";

/**
 * Resolves the onboarding step name from the current pathname.
 * Returns undefined if the pathname does not match any onboarding step path.
 */
export const getStepNameFromPathname = (
  pathname: string,
): StepName | undefined => {
  return getStepNameFromOnboardingPath(pathname);
};

export const getOnboardingStepPath = (stepName?: StepName): OnboardingPath => {
  return getSharedOnboardingStepPath(stepName);
};

export const getOnboardingAuthorizedStepPaths = (
  state: Pick<
    OnboardingResponseState,
    "completedSteps" | "currentStepName" | "shopConnected"
  >,
): OnboardingPath[] => {
  const resolutionContext = { shopConnected: Boolean(state.shopConnected) };

  return Array.from(
    new Set([
      ...(state.completedSteps ?? [])
        .filter((step) => !isOnboardingStepResolved(step, resolutionContext))
        .map((step) => getOnboardingStepPath(step)),
      ...(!isOnboardingStepResolved(state.currentStepName, resolutionContext)
        ? [getOnboardingStepPath(state.currentStepName)]
        : []),
    ]),
  );
};

export const transformResponseToStoreState = (
  state: OnboardingResponseState,
) => {
  const {
    onboardingId,
    answers,
    stepNumberInPath,
    currentStepName,
    shopConnected,
  } = state;
  const onboardingStepsPaths = getOnboardingAuthorizedStepPaths(state);

  return {
    onboardingId: onboardingId ?? null,
    onboardingLoadingState: isOnboardingLoadingStep(currentStepName)
      ? currentStepName
      : null,
    currentStepName: currentStepName,
    stepsCount: Math.max(stepNumberInPath ?? 0, onboardingStepsPaths.length),
    companyType: answers?.companyType?.value ?? null,
    onboardingStepsPaths,
    bookDemoAnswer: answers?.bookDemo?.value ?? null,
    shopConnected: {
      shopName: shopConnected?.shopName ?? null,
      shopType:
        answers?.connectShop?.value?.shopType ??
        shopConnected?.shopType ??
        null,
    },
  };
};
